var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextCore } from "../TextCore/TextCore";
import { classNameParserCore } from "../../coreFunctions/classNameParserCore/classNameParserCore";
/**
 * A reusable badge component that uses TextCore for consistent text styling.
 * @param {BadgeCoreProps} props - Props for the badge, including text content and container styles.
 */
export const BadgeCore = (_a) => {
    var { text, backgroundColor = "#f0f0f0", // Default light gray background
    padding = "4px 8px", // Default padding
    borderRadius = "4px", // Default rounded corners
    badgeStyle = {}, badgeClassName } = _a, 
    // Spread the rest of the props, which are TextCoreProps
    textCoreProps = __rest(_a, ["text", "backgroundColor", "padding", "borderRadius", "badgeStyle", "badgeClassName"]);
    const badgeContainerStyle = Object.assign({ backgroundColor,
        padding,
        borderRadius, display: "inline-flex", alignItems: "center", justifyContent: "center" }, badgeStyle);
    // Extract className from textCoreProps to use for TextCore
    const { className: textClassName } = textCoreProps, restOfTextCoreProps = __rest(textCoreProps, ["className"]);
    return (_jsx("div", { className: classNameParserCore(badgeClassName), style: badgeContainerStyle, children: _jsx(TextCore, Object.assign({ text: text, className: textClassName }, restOfTextCoreProps)) }));
};
